export const payGenerateKey = (
  type: string,
  id: string,
  paymentType: number,
) => ['usePayGenerate', type, id, paymentType]
